module.exports = __webpack_public_path__ + "static/img/banner-02.dd55b76e.jpg";